import { render, staticRenderFns } from "./Introrew.vue?vue&type=template&id=4b198e54"
import script from "./Introrew.vue?vue&type=script&lang=js"
export * from "./Introrew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports